import './home.scss';
import { Button } from '@mui/material';
import React, { useContext } from 'react';
import { baseSelectionneeContext } from '../../App';

const Home = ({ environnementsDisponibles }) => {
    const { baseSelectionnee, setBaseSelectionnee } = useContext(baseSelectionneeContext);

    const modifierBase = nouvelleBase => {
        return () => {
            setBaseSelectionnee(nouvelleBase);
            localStorage.setItem('baseSelectionnee', nouvelleBase);
        }
    };

    return (
        <div className="conteneur-home">
            <div>Bienvenue</div>
            <div className='selection-base'>
                {environnementsDisponibles && Object.entries(environnementsDisponibles).map(([env, details]) => (
                    <Button key={env} variant="contained" className={baseSelectionnee === env ? '' : 'bouton-blanc'}
                        style={{backgroundColor: `${details.boutonCSS}`}} onClick={() => modifierBase(env)}>
                        {details.nom}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default Home;
